import api from '@/api/invoices'

const getDefaultState = () => {
  return {
    invoiceCreated: false,
    invoices: [],
    createdInvoice: {},
    invoiceWarning: false
  }
}

const state = getDefaultState()

const mutations = {
  SET_INVOICE_FLAG: (state, value) => {
    state.invoiceCreated = value
  },
  SET_INVOICES: (state, list) => {
    state.invoices = list
  },
  SET_CREATED_INVOICE: (state, invoice) => {
    state.createdInvoice = invoice
  }
}

const actions = {
  clearInvoiceFlag ({ commit }) {
    commit('SET_INVOICE_FLAG', false)
  },
  async createInvoice ({ commit, rootState }) {
    commit('app/START_LOADING', '', { root: true })

    try {
      const body = {
        sale_order_ids: [...rootState.invoiceableSales.selectedSales],
        sat_fiscal_regime: rootState.invoiceableSales.selectedRegime,
        sat_postal_code: rootState.invoiceableSales.selectedZipCode
      }
      const { data } = await api.createInvoice(body)

      commit('SET_CREATED_INVOICE', data)
      commit('SET_INVOICE_FLAG', true)
      commit('sales/CLEAR_SELECTED_SALES', '', { root: true })
    } catch (error) {
      // TODO: Handle error
      commit('SET_INVOICE_FLAG', false)
      commit('app/FINISH_LOADING', '', { root: true })
      commit('invoiceableSales/RESET_STATE', false, { root: true })
      commit('invoiceableSales/SET_INVOICE_WARNING', false, { root: true })
    } finally {
      commit('app/FINISH_LOADING', '', { root: true })
    }
  },
  async getInvoices ({ commit }) {
    commit('app/START_LOADING', '', { root: true })
    try {
      const { data } = await api.getInvoices()

      commit('SET_INVOICES', data)
    } catch (error) {
      // TODO: Handle error
    } finally {
      commit('app/FINISH_LOADING', '', { root: true })
    }
  }
}

const getters = {
  invoiceCreated: state => state.invoiceCreated,
  invoices: state => state.invoices
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
